

import Vue from 'vue'
import App from './App/App.vue'
import router from './router'
import store from './store'

// 引入jquery
import $ from 'jquery'
window.$ = window.jQuery = $

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick.js'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import 'owl.carousel'
import 'select2'
import 'select2/dist/css/select2.min.css'

// import 'simplebar-vue/dist/simplebar.min.css'
// import '@splidejs/splide/dist/css/themes/splide-default.min.css'

// css 和 js 引进
// 在适当的地方调用这个函数
// async function loadCSS() {
//   if (process.env.VUE_APP_REGION == 'IN') {
//     await import("./assets/css/style_intl.css");
//     await import("./assets/css/style4_intl.css");
//     await import("./assets/css/header_intl.css");
//     await import("./assets/css/responsive_intl.css");
//   } else {
//     await import("./assets/css/style.css");
//     await import("./assets/css/style4.css");
//     await import("./assets/css/header.css");
//     await import("./assets/css/responsive.css");
//   }
// }
// loadCSS();
import "./assets/css/style.css";
import "./assets/css/style4.css";
import "./assets/css/header.css";
import "./assets/css/responsive.css";

if (process.env.VUE_APP_REGION === "TH") {
  import("@/assets/css/style_TH.css");
}

import custom from "./assets/js/custom.js";
Vue.prototype._$ = custom;




// 国际语言
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const messages = {
  'EN': require('./locales/EN.json')
}

// 如果环境变量存在，动态添加第二种语言
if (process.env.VUE_APP_LANGUAGE2) {
  messages[process.env.VUE_APP_LANGUAGE2] = require(`./locales/${process.env.VUE_APP_LANGUAGE2}.json`)
}

const urlParams = new URLSearchParams(window.location.search);
let Langa = urlParams.get('lang') || "";
if (Langa.toUpperCase() != "" && (Langa.toUpperCase() == process.env.VUE_APP_LANGUAGE1 || Langa.toUpperCase() == process.env.VUE_APP_LANGUAGE2)) {

  Langa = Langa.toUpperCase();

  if (Langa.toUpperCase() == process.env.VUE_APP_LANGUAGE1) {
    localStorage.setItem('Language', 1)

  } else if (Langa.toUpperCase() == process.env.VUE_APP_LANGUAGE2) {
    localStorage.setItem('Language', 2)
  }
}
else {
  if (localStorage.getItem("Language") != "" != undefined && localStorage.getItem("Language") != undefined) {
    if (localStorage.getItem("Language") == 1) {
      Langa = process.env.VUE_APP_LANGUAGE1
    } else {
      Langa = process.env.VUE_APP_LANGUAGE2
    }
  } else {

    if (process.env.VUE_APP_DEFAULT == "1") {

      localStorage.setItem('Language', 1)
      Langa = process.env.VUE_APP_LANGUAGE1;
    }
    else if (process.env.VUE_APP_DEFAULT == "2") {

      localStorage.setItem('Language', 2)
      Langa = process.env.VUE_APP_LANGUAGE2;
    }
    else {

      Langa = process.env.VUE_APP_LANGUAGE1;
    }
  }
}

const i18n = new VueI18n({
  locale: Langa, // 设置默认使用语言
  messages
})

router.i18n = i18n

import VueMeta from 'vue-meta'
Vue.use(VueMeta)


Vue.config.productionTip = false

new Vue({

  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
